import { Inject, Injectable, Optional } from '@angular/core';
import { BehaviorSubject, Observable, of, shareReplay } from 'rxjs';
import { OrderConfigMarket } from './order-config';

@Injectable({
  providedIn: 'root',
})
export class OrderConfigService {
  orderConfigMarketId$$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  orderConfigMarketId$: Observable<string> = this.orderConfigMarketId$$.asObservable().pipe(shareReplay(1));

  constructor(@Optional() @Inject('markets$') private markets$: Observable<OrderConfigMarket[]> = of([])) {}

  getMarkets(): Observable<OrderConfigMarket[]> {
    return this.markets$;
  }

  updateMarket(updatedMarketId: string): void {
    this.orderConfigMarketId$$.next(updatedMarketId);
  }
}
